//@flow
import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import FixedDataTable from 'common/components/core/table/FixedDataTable';
import { collapsibleListCardFactory } from 'common/components/core/card/CollapsibleListCard';
import { listCardFactory } from 'common/components/core/card/ListCard';
import theme from './CollapsibleTable.scss';
import { translate } from 'react-i18next';
import Icon, { ErrorIcon } from 'common/components/core/icon';

const Subtitle = ({ subtitleWarning, theme }) => {
    return subtitleWarning ? (
        <div className={theme.subtitleWarningContainer}>
            <ErrorIcon theme={theme} visible />
            <div className={theme.subtitle}>{subtitleWarning}</div>
        </div>
    ) : null;
};
const RightIcon = ({ rightIcon, rightText, theme }) => {
    return (
        <div className={theme.rightIconContainer}>
            <div className={theme.rightText}>{rightText}</div>
            <Icon
                icon={rightIcon}
                theme={theme}
                className={theme.rightIconWrap}
            />
        </div>
    );
};
const ListCard = listCardFactory({
    RightIcon,
    Subtitle
});
const TableCardComponent = ({
    title,
    subtitleWarning,
    onClick,
    isExpanded,
    t,
    theme,
    noRowsFound
}) => {
    return (
        <ListCard
            theme={theme}
            className={theme.tableTitleCard}
            onClick={!noRowsFound && onClick}
            title={title}
            subtitleWarning={subtitleWarning}
            rightText={noRowsFound ? '' : isExpanded ? t('hide') : t('show')}
            rightIcon={
                noRowsFound ? '' : isExpanded ? 'arrow-up' : 'arrow-down'
            }
            extraContent={noRowsFound ? t('noRowsFound') : null}
        />
    );
};
const collapsibleTableFactory = (
    Table: React.ComponentType<any> = FixedDataTable
) => {
    const CollapsibleTable = collapsibleListCardFactory({
        CardComponent: translate()(TableCardComponent),
        CollapseComponent: Table
    });
    class CollapsibleTableComponent extends React.PureComponent {
        render() {
            const {
                className,
                tableData: { rows },
                theme,
                isExpanded
            } = this.props;
            const noRowsFound = rows.size === 0;
            return (
                <CollapsibleTable
                    {...this.props}
                    noRowsFound={noRowsFound}
                    isExpanded={noRowsFound ? true : isExpanded}
                    className={classnames(className, {
                        [theme.noRowsFound]: noRowsFound
                    })}
                />
            );
        }
    }
    return themr('CollapsibleTable', theme)(CollapsibleTableComponent);
};
const CollapsibleFixedDataTable = collapsibleTableFactory();
export { CollapsibleFixedDataTable, collapsibleTableFactory };
export default CollapsibleFixedDataTable;
